/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ResultState } from './ResultState';
import {
    ResultStateFromJSON,
    ResultStateFromJSONTyped,
    ResultStateToJSON,
} from './ResultState';

/**
 * 
 * @export
 * @interface UpdateStateDto
 */
export interface UpdateStateDto {
    /**
     * 
     * @type {ResultState}
     * @memberof UpdateStateDto
     */
    state?: ResultState;
    /**
     * 
     * @type {string}
     * @memberof UpdateStateDto
     */
    $type?: UpdateStateDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateStateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateStateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateStateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateStateDtoTypeEnum = typeof UpdateStateDtoTypeEnum[keyof typeof UpdateStateDtoTypeEnum];



/**
 * Check if a given object implements the UpdateStateDto interface.
 */
export function instanceOfUpdateStateDto(value?: unknown): value is UpdateStateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateStateDtoTypeEnum)[0];
}

export function UpdateStateDtoFromJSON(json: any): UpdateStateDto {
    return UpdateStateDtoFromJSONTyped(json, false);
}

export function UpdateStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'state': json['state'] == null ? undefined : ResultStateFromJSON(json['state']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateStateDtoToJSON(value?: UpdateStateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'state': ResultStateToJSON(value['state']),
        '$type': value['$type'],
    });
}

